import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';

import { AnonymousSubscription } from 'rxjs/Subscription';

import { AppSettings } from '../config/app.settings';
import { Usuario } from '../models/usuario.model';
import { catchError, delay, finalize, retry, switchMap, timeout } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

@Injectable()
export class MacroService {

    constructor(
        @Inject(LOCAL_STORAGE) private storage: WebStorageService,
        private http: HttpClient) { }

    verificacionHeaderBlob() {
        let headersBlob = new HttpHeaders().set('mtkn', this.storage.get("idma")).set('sourceR', "web");
        return { headers: headersBlob, responseType: "blob" as "blob" }
    }

    verificacionHeaderArchivoAnormal() {
        let headersBlob = new HttpHeaders().set('mtkn', this.storage.get("idma")).set('sourceR', "web");
        return { headers: headersBlob, responseType: 'text' as 'json' }
    }

    verificacionHeaderNormal() {
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Access-Control-Allow-Origin', "*")
            .set('Content-Encoding', 'gzip')
            .set('mtkn', this.storage.get("idma"))
            .set('sourceR', "web");
        return { headers: headers };
    }

    verificacionHeaderNormalExtendTimeOut() {
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Access-Control-Allow-Origin', "*")
            .set('Content-Encoding', 'gzip')
            .set('mtkn', this.storage.get("idma"))
            .set('sourceR', "web")
            .set('timeout', `${3600000}`);
        return { headers: headers };
    }

    verificacionHeaderNormalRespuestaText() {
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Access-Control-Allow-Origin', "*")
            .set('Content-Encoding', 'gzip')
            .set('sourceR', "web")
            .set('mtkn', this.storage.get("idma"));
        return { headers: headers, responseType: 'text' as 'json' };
    }

    verificacionHeaderTexto() {
        let headers = new HttpHeaders()
            .set('Content-Type', 'text/plain')
            .set('Access-Control-Allow-Origin', "*")
            .set('Content-Encoding', 'gzip')
            .set('mtkn', this.storage.get("idma"))
            .set('sourceR', "web");
        return { headers: headers, responseType: null, observe: 'response' as 'body' };
    }

    verificacionHeaderNormalArchivo() {
        let headers = new HttpHeaders()
            .set('Accept', "multipart/form-data")
            .set('Access-Control-Allow-Origin', "*")
            .set('mtkn', this.storage.get("idma"))
            .set('sourceR', "web");
        const options: {
            headers?: HttpHeaders,
            observe?: 'body',
            params?: HttpParams,
            reportProgress?: boolean,
            responseType: 'text',
            withCredentials?: boolean
        } = {
            headers: headers,
            responseType: 'text'
        };
        return options;
    }

    verificacionHeaderCerrar(tok) {
        let headers = new HttpHeaders()
            .set('Access-Control-Allow-Origin', "*")
            .set('Content-Type', 'application/json')
            .set('mtkn', tok)
            .set('sourceR', "web");
        return { headers: headers };
    }

    verificacionHeaderInicial() {
        let headers = new HttpHeaders()
            .set('Access-Control-Allow-Origin', "*")
            .set('Content-Type', 'application/json')
            .set('mtkn', '85f424bb-cd46-4cfb-ae40-14f2f8c7ee13')
            .set('sourceR', "web");
        return { headers: headers };
    }

    empresas(): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas',
            this.verificacionHeaderNormal()).map(response => response);
    }

    consultaEmpresasCrm(idUsuario: string) {
        return this.http.get(`${AppSettings.API_ENDPOINT_USER}crm/usuarios/${idUsuario}/empresas`,this.verificacionHeaderNormal())
        .map(response => response)
        .catch(error => Observable.throw(error));
    }

    status(): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'status').map(response => response);
    }

    perfilesUsuario(nombreusuario: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'usuarios/' + nombreusuario + '/perfiles',
            this.verificacionHeaderNormal()).map(response => response);
    }

    formulariosUsuario(usuario: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'usuarios/' + usuario + '/formularios',
            this.verificacionHeaderNormal()).map(response => response);
    }

    formularioId(id: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'informacion/formularios/' + id,
            this.verificacionHeaderNormal()).map(response => response);
    }

    plantillaformularioId(id: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'formularios/' + id,
            this.verificacionHeaderNormal()).map(response => response);
    }

    tareasPorCliente(id: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + id + '/tareas',
            this.verificacionHeaderNormal()).map(response => response);
    }

    tareasPorFiltros(idEmpresa, nombre, zonaTrabajo, estado, nombreUsuario, ubicacion, fechaCrear, fechaProgramar, nombreTarea, fechaDesde, fechaHasta): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idEmpresa + '/tareas/filtros?'
            + 'formulario=' + nombre + '&zona=' + zonaTrabajo + '&estadoTarea=' + estado + '&usuario=' + nombreUsuario + '&ubicacion=' + ubicacion
            + '&creacion=' + fechaCrear + '&programacion=' + fechaProgramar + '&nombre=' + nombreTarea + '&fechaDesde=' + fechaDesde + '&fechaHasta=' + fechaHasta,
            this.verificacionHeaderNormal()).map(response => response);
    }

    ubicacionUsuariosPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'cliente/' + idCliente + '/ubicaciones',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    usuariosPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/usuarios',
            this.verificacionHeaderNormal()).map(response => response);
    }

    alertasPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idCliente + '/notificaciones',
            this.verificacionHeaderNormal()).map(response => response);
    }

    alertasPorUsuario(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'usuarios/' + idCliente + '/notificaciones',
            this.verificacionHeaderNormal()).map(response => response);
    }

    alertasActualizar(notificacion: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'notificaciones', notificacion, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    usuariosPorClienteParametros(idCliente: number, tipo: number): Observable<any> {
        const url = AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/usuarios/parametros?tipo=' + tipo;
        return this.http.get<Usuario[]>(url, this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    zonasPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/zonas',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    perfilesPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/perfiles',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    formulariosPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idCliente + '/formularios',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    segmentos(): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'utilidades/segmentos',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    ubicacionesPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/ubicaciones/generales',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    ubicacionesPorClienteZona(idCliente: number, idzona: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/zonastrabajo/' + idzona + '/ubicaciones',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    usuariosPorClienteZona(idCliente: number, idzona: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/zonastrabajo/' + idzona + '/usuarios',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    flujosPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/flujos',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    flujosPorFormulario(idCliente:number, idFormulario: string): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'flujos/' + idCliente + '/formulario/' + idFormulario,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    formulariosPorId(id: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'formularios/base/' + id,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    estadosPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/estados',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    listasPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idCliente + '/listas',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    masterPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idCliente + '/masters',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    consultarEmpresa(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    historialUbicacionPorUsuario(idUsuario: number, fechaInicio: string, fechaFin: string): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'ubicaciones/' + idUsuario + '?fechainicio=' +
            fechaInicio + '&fechafin=' + fechaFin, this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    consultarActividades(ubicacion: string, tipoFecha: number, zona: string, nombre: string, estado: string,
        nombreUsuario: string, fechaInicio: string, fechaFin: string, idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'clientes/' + idCliente + '/actividades?fechaInicio=' +
            fechaInicio + '&fechaFin=' + fechaFin + '&tipoFecha=' + tipoFecha + '&zona=' + zona +
            '&nombre=' + nombre + '&estado=' + estado + '&nombreUsuario=' + nombreUsuario + '&ubicacion=' + ubicacion,
            this.verificacionHeaderNormalExtendTimeOut()).timeout(210000).delay(60).map(response => response).catch(error => Observable.throw(error));
    }

    consultarActividadesPorUsuario(idUsuario: number, fechaInicio: string, fechaFin: string): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'usuarios/' + idUsuario + '/actividades?fechaInicio=' +
            fechaInicio + '&fechaFin=' + fechaFin,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    consultarActividadesPorUsuarioParcial(idUsuario: number, fechaInicio: string, fechaFin: string): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'usuarios/' + idUsuario + '/actividades/parcial?fechaInicio=' +
            fechaInicio + '&fechaFin=' + fechaFin,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    consultarUsuario(idUsuario: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'usuarios/' + idUsuario + '/identificacion',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    consultarUsuario2(idUsuario: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'usuarios/procesos/' + idUsuario,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    actualizarUsuario(user: Usuario): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'usuarios', user, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    suspenderUsuario(user: Usuario): Observable<any> {
        return this.http.delete(AppSettings.API_ENDPOINT_USER + 'usuarios/' + user.idusuario, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    borrarItem(idempresa: String, iditem: String): Observable<any> {
        return this.http.delete(AppSettings.API_ENDPOINT_MA_ITEM + 'empresas/'+idempresa+'/items/'+iditem , this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    borrarAgrupacionItem(iditemLista: String): Observable<any> {
        return this.http.delete(AppSettings.API_ENDPOINT_MA_ITEM + 'listaitems/' + iditemLista, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarUsuarioPerfil(user: any, list: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'usuarios/' + user + "/perfiles", list, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarFormulariosusuario(user: any, list: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'usuarios/' + user + "/formularios", list, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearUsuarioPerfil(user: any, list: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'usuarios/' + user + "/perfiles", list, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearUsuario(user: Usuario): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'usuarios', user, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarZonaTrabajo(objeto: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'zonas', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearZonaTrabajo(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'zonas', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarTarea(objeto: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'tareas', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    borrarTarea(objeto: any): Observable<any> {
        return this.http.delete(AppSettings.API_ENDPOINT_MA + 'tareas/movil/' + objeto.id, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    borrarTareasMasivas(cliente: any, tasks: any, borradounicomasivo: any, borrarhijos: any, usuario: any): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}tareas/movil/masiva?borradounicomasivo=${borradounicomasivo}&borrarhijos=${borrarhijos}&usuarioelimina=${usuario}`, tasks, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearTarea(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'tareas', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarEstado(objeto: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'estados', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearEstado(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'estados', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarPerfil(objeto: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'perfiles', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearPerfil(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'perfiles', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarUbicacion(objeto: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'ubicaciones', objeto, this.verificacionHeaderNormal())
            .map(response => response);
    }

    crearUbicacion(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'ubicaciones', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarFlujo(objeto: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'flujos', objeto, this.verificacionHeaderNormal())
            .catch(error => Observable.throw(error));
    }

    crearFlujo(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'flujos', objeto, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    eliminarFlujo(idFlujo: any): Observable<any> {
        return this.http.put(`${AppSettings.API_ENDPOINT_USER}flujos/${idFlujo}/eliminar`, {}, this.verificacionHeaderNormal())
            .catch(error => Observable.throw(error));
    }

    actualizarEmpresa(objeto: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'empresas', objeto, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    crearEmpresa(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'empresas', objeto, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    suspenderEmpresa(idempresa: any): Observable<any> {
        return this.http.delete(AppSettings.API_ENDPOINT_USER + 'empresas/' + idempresa, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    reportePdfActividad(idactividad: number): Observable<Blob> {
        return this.http.get(AppSettings.API_ENDPOINT_REPORTS + 'actividades/' + idactividad,
            this.verificacionHeaderBlob()).map(response => response).catch(error => Observable.throw(error));
    }

    reporteTiemposActividades(ubicacion: string, tipoFecha: number, zona: string, nombre: string, estado: string,
        nombreUsuario: string, fechaInicio: string, fechaFin: string, idCliente: number): Observable<Blob> {
        return this.http.get(AppSettings.API_ENDPOINT_REPORTS + 'reportes/clientes/' + idCliente + '/actividades?fechaInicio=' +
            fechaInicio + '&fechaFin=' + fechaFin + '&tipoFecha=' + tipoFecha + '&zona=' + zona +
            '&nombre=' + nombre + '&estado=' + estado + '&nombreUsuario=' + nombreUsuario + '&ubicacion=' + ubicacion,
            this.verificacionHeaderBlob()).map(response => response).catch(error => Observable.throw(error));
    }

    reporteActividades(ubicacion: string, tipoFecha: number, zona: string, nombre: string, estado: string,
        nombreUsuario: string, fechaInicio: string, fechaFin: string, idCliente: number): Observable<Blob> {
        return this.http.get(AppSettings.API_ENDPOINT_REPORTS + 'clientes/' + idCliente + '/actividades?fechaInicio=' +
            fechaInicio + '&fechaFin=' + fechaFin + '&tipoFecha=' + tipoFecha + '&zona=' + zona +
            '&nombre=' + nombre + '&estado=' + estado + '&nombreUsuario=' + nombreUsuario + '&ubicacion=' + ubicacion,
            this.verificacionHeaderBlob()).map(response => response).catch(error => Observable.throw(error));
    }

    actualizarListas(lista: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'empresas/listas', lista, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarMaster(master: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'empresas/masters', master, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarMaster(master: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/masters', master, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    eliminarMaster(idempresa: any, idmaster: any) {
        return this.http.delete(`${AppSettings.API_ENDPOINT_MA}empresas/${idempresa}/masters/${idmaster}/delete`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarFormulario(master: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA_FORMULARIOS + 'empresas/formularios', master, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    borrarFormulario(id: any): Observable<any> {
        return this.http.delete(AppSettings.API_ENDPOINT_MA + '/formularios/' + id, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarFormulario(master: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA_FORMULARIOS + 'empresas/formularios', master, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarGeocerca(geocerca: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'geocercas', geocerca, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarGeocerca(geocerca: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'geocercas', geocerca, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarGeocercasPorUsuario(idUsuario: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'usuarios/' + idUsuario + '/geocercas',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    crearListas(lista: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/listas', lista, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    verificarCredenciales(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'usuarios/procesos', objeto, this.verificacionHeaderInicial())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    verificarToken(): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'sesiones/existe/' + this.storage.get("idma"), this.verificacionHeaderInicial())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearSessionCloud(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'sesiones/crear', objeto, this.verificacionHeaderInicial())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearSession(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'sesiones/movil/crear', objeto, this.verificacionHeaderInicial())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearFactor(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'usuarios/factor', objeto, this.verificacionHeaderInicial())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    cerrarSession(value: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'sesiones/finalizar/' + value, {}, this.verificacionHeaderCerrar(value))
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarPerfilPorNombre(perfil: string): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'perfiles/' + perfil,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    uploadFile(objeto: FormData, idempresa: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_REPORTS + 'empresas/' + idempresa + '/uploadFile', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }

    uploadFileMA(objeto: FormData, nombre: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA_FORMULARIOS + 'formulario/' + nombre + '/uploadFile', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }

    uploadFileExcelUbicaciones(objeto: FormData, idempresa: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'empresas/' + idempresa + '/ubicaciones', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }

    uploadFileExcelListas(objeto: FormData, idempresa: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/' + idempresa + '/listas', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }

    uploadFileTarea(objeto: FormData, idtarea: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_REPORTS + 'tareas/' + idtarea + '/uploadFile', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }

    verificarNombreUsuario(usuario: string): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'usuarios/existe/' + usuario,
            this.verificacionHeaderNormal()).map(response => response);
    }

    // ITEMS
    consultarItemsPorCliente(idempresa: string): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idempresa + '/items',
            this.verificacionHeaderNormal()).map(response => response);
    }

    crearItemPorCliente(item: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/items', item, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarItemPorCliente(item: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA_ITEM + 'empresas/items', item, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    consultarListaItems(idEmpresa: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idEmpresa + '/listaitems', this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarItemId(idItem: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'items/' + idItem , this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarListaItemsSencilla(idEmpresa: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idEmpresa + '/listaitems/sencilla', this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarListaItemsId(id: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'listaitems/' + id , this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearListaItemsCliente(listaItem: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/listaitems', listaItem, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    editarListaItemsCliente(lsitaItem: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA_ITEM + 'empresas/listaitems', lsitaItem, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    uploadFileExcelItems(objeto: FormData, idempresa: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/' + idempresa + '/items', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }
    // FIN ITEMS

    // OBJETOS
    consultarObjetosPorCliente(idempresa: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idempresa + '/objetos',
            this.verificacionHeaderNormal()).map(response => response);
    }

    crearObjetoPorCliente(Objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/objetos', Objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarObjetoPorCliente(objeto: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA_ITEM + 'empresas/objetos', objeto, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    consultarListaObjetos(idEmpresa: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idEmpresa + '/listaobjetos', this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearListaObjetosCliente(listaItem: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/listaobjetos', listaItem, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    editarListaObjetosCliente(lsitaItem: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA_ITEM + 'empresas/listaobjetos', lsitaItem, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    uploadFileExcelObjetos(objeto: FormData, idempresa: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/' + idempresa + '/objetos', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }
    // FIN OBJETOS

    estadosMovilPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/estadosmoviles',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    crearEstadoMovilCliente(estadoMovil: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'estadosmoviles', estadoMovil, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarEstadoMovilCliente(estadoMovil: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'estadosmoviles', estadoMovil, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarFactor(id_usuario: String) {
        var options = this.verificacionHeaderTexto();
        options.responseType = 'text';
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'usuarios/' + id_usuario + '/factor', options)
            .map(response => response).catch(error => Observable.throw(error));
    }

    consultarPlantillasPDF(idEmpresa: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idEmpresa + '/plantillas', this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarPlantillasPDFByUsuario(idusuario: any): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}plantillas/${idusuario}/usuario`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarPlantillasPDFlivianas(idEmpresa: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idEmpresa + '/plantillas/livianas', this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    plantillaPDFPorId(idPDF: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'plantillas/' + idPDF, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarPlantillaPDF(plantilla: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'plantillas', plantilla, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    atualizarPlantillaPDF(idPlantilla: any, plantilla: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'plantillas/' + idPlantilla, plantilla, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    reportePdfPersonalizado(ubicacion: string, tipoFecha: number, zona: string, nombre: string, estado: string,
        nombreUsuario: string, fechaInicio: string, fechaFin: string, idCliente: number, pdf: number) {

    }

    consultarConfiguracionAlertas(idEmpresa: any) {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idEmpresa + '/alertasconfiguracion', this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarConfiguracionAlertas(configuracionAlerta: any) {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'alertasconfiguracion', configuracionAlerta, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    eliminarConfiguracionAlertas(id) {
        return this.http.delete(AppSettings.API_ENDPOINT_MA + 'alertasconfiguracion/' + id, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    atualizarConfiguracionAlertas(configuracionAlerta: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'alertasconfiguracion', configuracionAlerta, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    actualizarpersonaAccesoCampo(idempresa: string,nombreCampo: string): Observable<any> {
         var campo = {campo:nombreCampo}
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'clientes/'+idempresa+'/camposPersona/control', campo, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    consultarListasAcceso(idEmpresa: any) {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idEmpresa + '/listasacceso', this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarListaAcceso(listaAcceso: any) {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/listasacceso', listaAcceso, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    guardarListaAccesoFile(file: FormData, idEmpresa: any, idListaAcceso: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/' + idEmpresa + '/listasacceso/' + idListaAcceso + '/file', file, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }

    guardarListaItem(listaItem: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/listaitems' , this.verificacionHeaderNormalExtendTimeOut)
            .map(response => response).catch(error => Observable.throw(error));
    }

    borrarListaAcceso(id: any): Observable<any> {
        return this.http.delete(AppSettings.API_ENDPOINT_MA + '/listasacceso/' + id, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    atualizarListaAcceso(listaAcceso: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'empresas/listasacceso', listaAcceso, this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    consultarZonasSecundariasUsuario(id_usuario: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'usuarios/' + id_usuario + '/zonasusuario', this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    guardarZonasSecundariasUsuario(zonasSecunsarias: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'zonasusuario', zonasSecunsarias, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    listasOnlinePorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idCliente + '/listasonline',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    actualizarListasOnline(lista: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'empresas/listasonline', lista, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearListasOnline(lista: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/listasonline', lista, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    uploadFileExcelListasOnline(objeto: FormData, idempresa: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/' + idempresa + '/listasonline', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }

    consultarTanques(idEmpresa: String) {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idEmpresa + '/tanques', this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    guardarTanque(tanque: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'tanques', tanque, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarTanque(tanque: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'tanques', tanque, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarInformacionUbicacionTanque(idTanque: String) {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'tanques/' + idTanque + '/informaciontanque', this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    guardarInformacionTanque(informacionTanque: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_USER + 'informaciontanque', informacionTanque, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    uploadFileExcelInformacionTanque(objeto: FormData, idempresa): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'empresas/' + idempresa + '/informaciontanque/masiva', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }

    listarHistoricoTarea(idTarea: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'tareas/' + idTarea + '/historico',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    obtenerTareaId(idTarea): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'tareas/movil/' + idTarea,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    listarHistoricoActividad(idActividad: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'historico/informacion/formularios/' + idActividad,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    listarHistoricoEstadoActividad(idActividad: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'historico/informacion/formularios/' + idActividad + '/estados',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    uploadFileExcelTareas(objeto: FormData, idempresa: any, idformulario: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/' + idempresa + '/tareas/formulario/' + idformulario, objeto, this.verificacionHeaderArchivoAnormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    downloadExcelHistoricoTareas(idTarea: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'tareas/' + idTarea + '/historico/download', this.verificacionHeaderBlob())
            .map(response => response).catch(error => Observable.throw(error));
    }

    reporteHistoricoRastero(data: any): Observable<Blob> {
        return this.http.post(AppSettings.API_ENDPOINT_REPORTS + 'usuarios/historicorastreo', data,
            this.verificacionHeaderBlob()).map(response => response).catch(error => Observable.throw(error));
    }

    actualizarActividad(objeto: any, usuario: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'informacion/' + objeto.id + '/formularios/usuario?usuario=' + usuario, objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    enviarParaFlujo(objeto: any, idformulario: any) {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'formulario/' + idformulario + '/flujo/', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarCrearTareaActividad(objeto: any, usuario: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'tareas/movil/inicial', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    newActualizarCrearTareaActividad(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'tareas/movil/redespacho', objeto, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearActividad(objeto: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'informacion/formularios', objeto, this.verificacionHeaderNormalRespuestaText())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    crearPqr(pqr: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'pqr', pqr, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarFestivo(festivo: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'empresas/festivos', festivo, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    festivosPorCliente(idCliente: number): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_USER + 'empresas/' + idCliente + '/festivos',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    notificacionTieneControlAcceso(data): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'notificacion/controlacceso', data, this.verificacionHeaderNormalRespuestaText())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    eliminarLista(data): Observable<any> {
        return this.http.delete(AppSettings.API_ENDPOINT_MA + 'lista/eliminar/' + data, this.verificacionHeaderNormalRespuestaText())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    setEstadoNotificacionMasivo(idEmpresa, data: any) {
        return this.http.delete(`${AppSettings.API_ENDPOINT_MA}empresas/${idEmpresa}/notificaciones/leidas/masivo?fechaInicio=${data.fechaInicio}&fechaFin=${data.fechaFin}&estado=${data.estado}&observacion=${data.observacion}`, this.verificacionHeaderNormalRespuestaText())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    borrarUbicacion(ubicacion: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_USER + 'ubicaciones/baja', ubicacion, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    reporteExcelUsuarios(id: number): Observable<Blob> {
        return this.http.get(AppSettings.API_ENDPOINT_REPORTS + 'empresas/' + id + "/usuarios",
            this.verificacionHeaderBlob()).map(response => response).catch(error => Observable.throw(error));
    }

    reporteExcelInformacionRequerida(): Observable<Blob> {
        return this.http.get(AppSettings.API_ENDPOINT_REPORTS + 'empresas/informacion/requerida',
            this.verificacionHeaderBlob()).map(response => response).catch(error => Observable.throw(error));
    }

    consultarPlantillasExcelConfiguracion(idCliente: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'empresas/' + idCliente + '/excelpersonalizado',
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    consultarPlantillasExcelConfiguracionByUsuario(idusuario: any): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}/excelpersonalizado/${idusuario}/usuario`,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    plantillaExcelConfiguracionPorId(idexclConfig: any): Observable<any> {
        return this.http.get(AppSettings.API_ENDPOINT_MA + 'excelpersonalizado/' + idexclConfig,
            this.verificacionHeaderNormal()).map(response => response).catch(error => Observable.throw(error));
    }

    atualizarPlantillaexcelConfiguracion(dataExlsConfig: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'excelpersonalizado/', dataExlsConfig, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    eliminarPlantillaexcelConfiguracion(dataExlsConfig: any): Observable<any> {
        return this.http.put(AppSettings.API_ENDPOINT_MA + 'excelpersonalizado/eliminar', dataExlsConfig, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarPlantillaexcelConfiguracion(dataExlsConfig: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'excelpersonalizado/', dataExlsConfig, this.verificacionHeaderNormalRespuestaText())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    obtenerCorreosConfiguracion(): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}configuracioncorreos`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarConfiguracionCorreo(data: any): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}configuracioncorreos`, data, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarConfiguracionCorreos(data: any, correo: string): Observable<any> {
        return this.http.put(`${AppSettings.API_ENDPOINT_MA}configuracioncorreos/${correo}`, data, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    eliminarConfiguracionCorreo(correo: any): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}configuracioncorreos/delete`, correo, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    filterUsers(filter: any, idempresa: any): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_USER}usuarios/${idempresa}/filtros?usuario=${filter.usuario}&estado=${filter.estado}&tipoUsuario=${filter.tipoUsuario}&documento=${filter.documento}`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    filterAlerts(filter: any, idempresa: any): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}notificaciones/${idempresa}/filtros?usuario=${filter.usuario}&estado=${filter.estado}&tipo=${filter.tipo}&fechainicio=${filter.fechainicio}&fechafin=${filter.fechafin}&clasificacion=${filter.clasificacion}`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    borrarUbicacionesMasivas(cliente: any, ubicaciones: any): Observable<any> {
        return this.http.put(`${AppSettings.API_ENDPOINT_USER}ubicaciones/delete/masivo`, ubicaciones, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    buscarUbicacionesClienteUsuario(idCliente, idUsuario): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}cliente/${idCliente}/ubicaciones/${idUsuario}/usuario`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    reenviarTareasUsuarios(idEmpresa: any, usuario: any): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}empresas/${idEmpresa}/usuarios/${usuario}/reenvio`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    erroresMovilByClienteUsuario(idempresa, idusuario, fInicio, fFin): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}empresas/${idempresa}/errores?idusuario=${idusuario}&fechainicio=${fInicio}&fechafin=${fFin}`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarAgrupacionUbicacionesCliente(idEmpresa: any): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}empresas/${idEmpresa}/agrupacionubicacion`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarAgrupacionUbicacion(agrupacionUbicacion: any): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}agrupacionubicacion`, agrupacionUbicacion, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarAgrupacionUbicacion(agrupacionUbicacion: any): Observable<any> {
        return this.http.put(`${AppSettings.API_ENDPOINT_MA}agrupacionubicacion`, agrupacionUbicacion, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    eliminarAgrupacionUbicacion(agrupacionUbicacionId: any): Observable<any> {
        return this.http.delete(`${AppSettings.API_ENDPOINT_MA}agrupacionubicacion/${agrupacionUbicacionId}`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarConfiguracionAutomatizacionAlertas() {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}automatizacionalertas`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarConfiguracionAutomatizacionAlertas(confAlertas: any): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}automatizacionalertas`, confAlertas, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarConfiguracionAutomatizacionAlertas(confAlertas: any): Observable<any> {
        return this.http.put(`${AppSettings.API_ENDPOINT_MA}automatizacionalertas`, confAlertas, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    eliminarConfiguracionAutomatizacionAlertas(confAlertas: any): Observable<any> {
        return this.http.delete(`${AppSettings.API_ENDPOINT_MA}automatizacionalertas/${confAlertas.id}`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarNotificacionProveedor(idInformarProveedor: any): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_USER}informes/1`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarNotificaionesProveedor(): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_USER}informes/`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    guardarInformarProveedor(informe: any): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_USER}informes/`, informe, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    actualizarInformarProveedor(informe: any, idinforme: any): Observable<any> {
        return this.http.put(`${AppSettings.API_ENDPOINT_USER}informes/${idinforme}`, informe, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarNotificaionesProveedorLeidos(idempresa: any): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_USER}informes/${idempresa}/leidos`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    consultarNotificaionesProveedorNoLeidos(idempresa: any): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_USER}informes/${idempresa}/sinleer`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    descargarListasSimples(idEmpresa: any): Observable<Blob> {
        return this.http.get(`${AppSettings.API_ENDPOINT_REPORTS}empresas/${idEmpresa}/listas`, this.verificacionHeaderBlob())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    uploadListasActualizar(objeto: FormData, idempresa: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/' + idempresa + '/listas/xls/actualizar', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }

    uploadListasActualizarUna(objeto: FormData, idempresa: any): Observable<any> {
        return this.http.post(AppSettings.API_ENDPOINT_MA + 'empresas/' + idempresa + '/listas/xls/actualizar/una', objeto, this.verificacionHeaderNormalArchivo())
            .map(response => response).catch(error => Observable.throw(error));
    }

    descargarListaSimple(lista: any): Observable<Blob> {
        return this.http.post(`${AppSettings.API_ENDPOINT_REPORTS}empresas/listas`, lista, this.verificacionHeaderBlob())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    getImagenTarea(id: any): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}tareas/imagen/${id}`, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    toDeleteSelectedActivities(idCliente: number, activities: string[], nombreCliente: string, usuarioDeleted: string, idUsuarioDeleted: string): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}clientes/${idCliente}/actividades/paraeliminar?nombreCliente=${nombreCliente}&usuarioDeleted=${usuarioDeleted}&idUsuarioDeleted=${idUsuarioDeleted}`, activities,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    consultarActividadesPorEliminar(): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}actividades/poreliminar`,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    elimiarActividades(activities: string[]): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}actividades/eliminar`, activities,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    cancelarEliminarACtividades(activities: string[]): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}actividades/cancelareliminar`, activities,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    crearEmpresaMa(empresa: any): Observable<any> {
        return this.http.put(`${AppSettings.API_ENDPOINT_MA}empresas`, empresa,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    getEmpresaMa(idEmpresa: string): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}empresa/${idEmpresa}`,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    getPlantillasPDFhtmlEmpresa(idEmpresa: string): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}empresas/${idEmpresa}/html/plantillas`,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    guardarPlantillasPDFhtmlEmpresa(pnatilla: any): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}html/plantillas`, pnatilla,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    eliminarPlantillasPDFhtmlEmpresa(idPlantilla: any): Observable<any> {
        return this.http.delete(`${AppSettings.API_ENDPOINT_MA}html/plantillas/${idPlantilla}`,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    getCarpetasFormulariosEmpresa(idEmpresa: string): Observable<any> {
        return this.http.get(`${AppSettings.API_ENDPOINT_MA}empresas/${idEmpresa}/carpetas_formularios`,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    guardarCarpetaEmpresa(carpeta: any): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}empresas/carpetas_formularios`, carpeta,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    asiociarFormulariosrCarpetaEmpresa(idCarpeta: string, usuarioUpdated: string, formluarios: any[]): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}empresas/carpetas_formularios/${idCarpeta}/${usuarioUpdated}`, formluarios,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    actualizarCarpetaEmpresa(carpeta: any): Observable<any> {
        return this.http.put(`${AppSettings.API_ENDPOINT_MA}empresas/carpetas_formularios`, carpeta,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    eliminarCarpetaFormularios(idCarpeta: any): Observable<any> {
        return this.http.delete(`${AppSettings.API_ENDPOINT_MA}empresas/carpetas_formularios/${idCarpeta}`,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    guardarCargaMasivaItems(idItem: any,lista: any): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}items/${idItem}/actualizacion/masiva`, lista, this.verificacionHeaderNormal())
            .map(response => response)
            .catch(error => Observable.throw(error));
    }

    filtrarPtt(filtro: any): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}ptt`,filtro,
            this.verificacionHeaderNormal())
            .map(response => response).catch(error => Observable.throw(error));
    }

    cargaEdemco(): Observable<any> {
        return this.http.post(`${AppSettings.API_ENDPOINT_MA}actividades/edemco/carga`,undefined, this.verificacionHeaderNormal())
        .map(response => response)
        .catch(error => Observable.throw(error));       
    }
    

}



// WEBPACK FOOTER //
// ./src/app/shared/services/macro.service.ts